// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1g5qx","vLegacy":"SelectSecondary_vLegacy__oIEJB","error":"SelectSecondary_error__1Nvm1","disabled":"SelectSecondary_disabled__1WoaH"};